import api from './chatAxiosConfig';

const chatApi = {
  getMessages: async (chatRoomId, { page = 1, limit = 10, search = '' } = {}) => {
    const res = await api.get(`/messages/${chatRoomId}`, {
      params: { page, limit, search },
    });
    return res.data?.data || [];
  },

  getChatListApiTrigger: async () => {
    const res = await api.get('/list');
    return res.data?.data || [];
  },

  createOrGetChatRoom: async (userID) => {
    const res = await api.post('/create-or-get', {
      otherUserId: userID,
    });
    return res?.data;
  },

  getAllEmployeesList: async ({ page = 1, limit = 50, search = '' }) => {
    const res = await api.get('/get-all-employees', {
      params: {
        page,
        limit,
        search,
      },
    });

    return res.data || {};
  },

  removeMemberFromGroup: async (chatRoomId, memberId) => {
    const res = await api.post('/group/remove-member', {
      chatRoomId,
      memberId,
    });
    return res?.data;
  },

  leaveGroup: async (chatRoomId) => {
    const res = await api.post('/group/leave', {
      chatRoomId,
    });
    return res?.data;
  },

  deleteGroup: async (chatRoomId) => {
    const res = await api.delete('/group/delete', {
      data: { chatRoomId },
    });
    return res?.data;
  },

  createGroup: async (groupName, memberIds, rowDetails) => {
    const res = await api.post('/group/create', {
      groupName,
      memberIds,
      reference_id: rowDetails?.expense_id,
      description: rowDetails?.description,
      profile_pic: rowDetails?.profile_pic,
    });
    return res?.data;
  },

  addMemberToGroup: async (chatRoomId, memberIds) => {
    const res = await api.post('/group/add-members', {
      chatRoomId,
      memberIds,
    });
    return res?.data;
  },

  updateGroup: async (rowDetails) => {
    const res = await api.put('/group/update', {
      chatRoomId: rowDetails?.chatRoomId,
      name: rowDetails?.groupName,
      photo: rowDetails?.profile_pic,
      description: rowDetails?.description,
    });
    return res?.data;
  },

  getGroupInfo: async (chatRoomId) => {
    const res = await api.get(`/group/get-data?chatRoomId=${chatRoomId}`);
    return res?.data;
  },
};

export default chatApi;
